import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';

@Component({
  selector: 'app-data-sent-latency',
  standalone: true,
  imports: [
    MatIconModule,
  ],
  templateUrl: './data-sent-latency.component.html',
  styleUrl: './data-sent-latency.component.scss'
})
export class DataSentLatencyComponent implements CellRenderer<any> {
  @Input() params!: CellRendererParams<any>;

  openLogDetailModal(element): void {
    this.params.colDef?.cellRendererParams?.onClick(element);
  }
}
